import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Carte temps réel (Leaflet + OpenStreetMap) — position livreur + point de dépôt.
export const LiveMap = ({ driver, dropoff, height = 260 }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const driverMarker = useRef(null);
  const dropMarker = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    const center = driver ? [driver.lat, driver.lon] : dropoff ? [dropoff.lat, dropoff.lon] : [46.82, 6.85];
    const map = L.map(ref.current, { zoomControl: true, attributionControl: false }).setView(center, 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map);
    mapRef.current = map;
    // Le conteneur peut être hors écran / de taille 0 au montage → forcer le recalcul.
    const fix = () => { try { map.invalidateSize(); } catch { /* map détruite */ } };
    const t1 = setTimeout(fix, 200);
    const t2 = setTimeout(fix, 600);
    let ro;
    if (typeof ResizeObserver !== "undefined") { ro = new ResizeObserver(fix); ro.observe(ref.current); }
    return () => { clearTimeout(t1); clearTimeout(t2); if (ro) ro.disconnect(); try { map.stop(); map.off(); } catch { /* noop */ } map.remove(); mapRef.current = null; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const bounds = [];

    if (dropoff) {
      const icon = L.divIcon({ className: "", html: `<div style="background:#0b1220;color:#fff;border-radius:9999px;width:26px;height:26px;display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 2px 6px rgba(0,0,0,.4)">🏠</div>`, iconSize: [26, 26], iconAnchor: [13, 13] });
      if (!dropMarker.current) dropMarker.current = L.marker([dropoff.lat, dropoff.lon], { icon }).addTo(map);
      else dropMarker.current.setLatLng([dropoff.lat, dropoff.lon]);
      bounds.push([dropoff.lat, dropoff.lon]);
    }
    if (driver) {
      const icon = L.divIcon({ className: "", html: `<div style="background:#f97316;color:#fff;border-radius:9999px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:15px;box-shadow:0 2px 8px rgba(249,115,22,.6)">🛵</div>`, iconSize: [28, 28], iconAnchor: [14, 14] });
      if (!driverMarker.current) driverMarker.current = L.marker([driver.lat, driver.lon], { icon }).addTo(map);
      else driverMarker.current.setLatLng([driver.lat, driver.lon]);
      bounds.push([driver.lat, driver.lon]);
    }
    if (bounds.length === 2) map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    else if (bounds.length === 1) map.setView(bounds[0], 14);
  }, [driver, dropoff]);

  return <div ref={ref} data-testid="ps-live-map" style={{ height, width: "100%", borderRadius: 14, overflow: "hidden", zIndex: 0 }} />;
};
